import MaintenanceEnabled from "./MaintenanceEnabled";

/**
 * Helper function to throw an error class
 *
 * @param {object} error
 * @returns {object}
 */
function getPrefixFromUrl(url) {
  const prefixMap = {
    nch: "/nch",
    mdl: "/mdl",
    odp: "/odp",
    rvd: "/rvd",
    rvo: "/rvo",
    vdl: "/vdl",
  };

  // Find the first matching prefix key in the URL
  const matchedKey = Object.keys(prefixMap).find((key) => url.includes(key));

  // Return the matching prefix or default to '/dv'
  return matchedKey ? prefixMap[matchedKey] : "/dv";
}

export default function errorHandler(url, error) {
  const prefix = getPrefixFromUrl(url);

  switch (error?.response?.status) {
    case 503: // Under Maintenance
      throw new MaintenanceEnabled(error);
    case 401: // Unauthorized
      window.location = `${prefix}/timeout`;
      break;
    case 403:
    case 404:
    case 400:
      window.location = process.env.REACT_APP_EDL_URL; // Redirect to landing URL to log back in
      break;
    case 500:
      if (error?.response?.data?.error === "missing_session_attributes") {
        window.location = process.env.REACT_APP_EDL_URL;
      } else {
        throw error;
      }
      break;
    default:
      throw error;
  }
}
